import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3" }

import Api from '@/services/api'
    import { onBeforeMount } from 'vue'
    import { ref } from 'vue';
    import { ElMessageBox } from 'element-plus';
    import { Order } from '@/services/types/order';
    import { Paginated } from '@/services/types/paginated';
    import { defaultPaginated } from '@/utilities/helpers';
    import PaginatedTable from '@/components/PaginatedTable.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PendentsView',
  setup(__props) {

    const loading = ref<boolean>(true)
    const data = ref<Paginated<Order>>(defaultPaginated)

    const getOrders = async (p = 1) => {
        loading.value = true
        const res = await Api.get(`admin/orders?new=on&page=${p}`)
        if (res.status == 200) {
            data.value = res.data.orders
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
        loading.value = false
    }

    onBeforeMount(() => {
        getOrders(1)
    })

    const changePage = (p = 1) => {
        getOrders(p)
    } 

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { header: "Pedidos pendentes" }, {
      default: _withCtx(() => [
        _createVNode(PaginatedTable, {
          loading: loading.value,
          page: data.value.current_page,
          "show-rows": 10,
          pages: data.value.last_page,
          data: data.value.data,
          height: 450,
          cols: [
                {label: 'Cod', prop: 'id'},
                {label: 'Estado', prop: 'status'},
                {label: 'Contacto', prop: 'phone'},
            ],
          onChange: changePage
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { label: "Cliente" }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.row.user?.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Entregador" }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.row.delivery?.name ?? '----'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Data e hora" }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(new Date(data.row.created_at).toLocaleString()), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Ver mais" }, {
              default: _withCtx((data) => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  tag: "router-link",
                  to: '/requests/' + data.row.id,
                  icon: "View",
                  title: "Ver mais"
                }, null, 8, ["to"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "page", "pages", "data"])
      ]),
      _: 1
    })
  ]))
}
}

})